const STORAGE_KEY = 'cyclon_withdrawal_reference';

export function createWithdrawalReference() {
  const randomPart =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID().replaceAll('-', '')
      : `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}`;

  return `arr_a${randomPart.slice(0, 23).toLowerCase()}`;
}

function initializeWithdrawalForm() {
  const form = document.querySelector('[data-cyclon-withdrawal-form]');
  if (!form) return;

  const referenceInput = form.querySelector('[name="contact[Referencia]"]');
  const dateInput = form.querySelector('[name="contact[Fecha de solicitud]"]');
  const confirmation = document.querySelector('[data-cyclon-withdrawal-confirmation]');
  const url = new URL(window.location.href);

  if (url.searchParams.get('contact_posted') === 'true') {
    const submittedReference = sessionStorage.getItem(STORAGE_KEY);
    if (confirmation && submittedReference) {
      confirmation.textContent =
        `Recibimos tu solicitud. Referencia: ${submittedReference}. Conservá este número para el seguimiento.`;
      confirmation.hidden = false;
    }
    sessionStorage.removeItem(STORAGE_KEY);
  }

  const ensureReference = () => {
    const reference = referenceInput?.value || createWithdrawalReference();
    if (referenceInput) referenceInput.value = reference;
    if (dateInput) dateInput.value = new Date().toISOString();
    sessionStorage.setItem(STORAGE_KEY, reference);
  };

  ensureReference();
  form.addEventListener('submit', ensureReference);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWithdrawalForm, { once: true });
} else {
  initializeWithdrawalForm();
}
